import { Typography } from "@mui/material";
import PropTypes from "prop-types";

export default function TextWithIcon({
  text,
  iconSrc,
  alt = "icon",
  className = "",
  iconClassName = "",
  href,
  target = "_self",
  textClassName = ""
}) {
  const Wrapper = href ? "a" : "div";

  return (
    <Wrapper
      href={href}
      target={href ? target : undefined}
      rel={href && target === "_blank" ? "noopener noreferrer" : undefined} 
      className={`flex items-center gap-2 ${className}`}>
      {iconSrc && (
        <img
          src={iconSrc}
          alt={alt}
          className={`w-4 h-4 ${iconClassName}`}
        />
      )}

      <Typography className={textClassName}>
        {text}
      </Typography>
    </Wrapper>
  );
}

TextWithIcon.propTypes = {
  text: PropTypes.string.isRequired,
  iconSrc: PropTypes.string,
  alt : PropTypes.string,
  className : PropTypes.string,
  iconClassName : PropTypes.string,
  href: PropTypes.string,
  target:  PropTypes.string,
  textClassName: PropTypes.string
};

